import transactionHistoryTypes from './types';

// Fetch all tranactions
export const fetchTransactionHistory = ({
  page,
  size,
  name,
  platform,
  status,
}) => ({
  type: transactionHistoryTypes.FETCH_TRANSACTIONS_HISTORY_START,
  data: { page, size, name, platform, status },
});
export const fetchTransactionHistorySuccess = (payload) => ({
  type: transactionHistoryTypes.FETCH_TRANSACTIONS_HISTORY_SUCCESS,
  payload,
});
export const fetchTransactionHistoryFailure = (error) => ({
  type: transactionHistoryTypes.FETCH_TRANSACTIONS_HISTORY_FAILURE,
  error,
});

// query transactions
export const queryTransaction = (ref, cb) => ({
  type: transactionHistoryTypes.QUERY_TRANSACTION_START,
  data: { ref, cb },
});
export const queryTransactionSuccess = (payload) => ({
  type: transactionHistoryTypes.QUERY_TRANSACTION_SUCCESS,
  payload,
});
export const queryTransactionFailure = (error) => ({
  type: transactionHistoryTypes.QUERY_TRANSACTION_FAILURE,
  error,
});

// query multiple transactions
export const queryMultiTransaction = (startFrom, cb) => ({
  type: transactionHistoryTypes.QUERY_MULTIPLE_TRANSACTIONS_START,
  payload: { startFrom, cb },
});
export const queryMultiTransactionSuccess = () => ({
  type: transactionHistoryTypes.QUERY_MULTIPLE_TRANSACTIONS_SUCCESS,
});
export const queryMultiTransactionFailure = (error) => ({
  type: transactionHistoryTypes.QUERY_MULTIPLE_TRANSACTIONS_FAILURE,
  error,
});

// export transactions
export const exportTransactions = (data, cb) => ({
  type: transactionHistoryTypes.EXPORT_TRANSACTION_START,
  payload: { data, cb },
});
export const exportTransactionsSuccess = () => ({
  type: transactionHistoryTypes.EXPORT_TRANSACTION_SUCCESS,
});
export const exportTransactionsFailure = (error) => ({
  type: transactionHistoryTypes.EXPORT_TRANSACTION_FAILURE,
  error,
});